import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UIRouterModule } from '@uirouter/angular';
import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { ApiModule } from '../api/api.module';
import { FolderPathComponent } from '../components/folders/folder-path/folder-path.component';
import { DialogHeaderComponent } from '../components/modals/dialog-header/dialog-header.component';
import { NoResultsComponent } from '../components/no-results/no-results.component';
import { OperationsMenuComponent } from '../components/operations-menu/operations-menu.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { FilesListComponent } from './components/files-list/files-list.component';
import { FolderSelectorModalComponent } from './components/folder-selector-modal/folder-selector-modal.component';
import { ListGridToggleComponent } from './components/list-grid-toggle/list-grid-toggle.component';
import { NewFolderModalComponent } from './components/new-folder-modal/new-folder-modal.component';
import { RenameFileModalComponent } from './components/rename-file-modal/rename-file-modal.component';
import { StorageGridViewComponent } from './components/storage-grid-view/storage-grid-view.component';
import { StorageHomeComponent } from './components/storage-home/storage-home.component';
import { StorageIframeComponent } from './components/storage-iframe/storage-iframe.component';
import { StorageListViewComponent } from './components/storage-list-view/storage-list-view.component';
import { StorageModalComponent } from './components/storage-modal/storage-modal.component';
import { StorageSelectorComponent } from './components/storage-selector/storage-selector.component';
import { ThumbnailImageComponent } from './components/thumbnail-image/thumbnail-image.component';
import { UploadComponent } from './components/upload/upload.component';
import { StorageFileNamePipe } from './pipes/storage-file-name.pipe';
import { StorageFileSizePipe } from './pipes/storage-file-size.pipe';
import { StorageFileTypePipe } from './pipes/storage-file-type.pipe';
import { routes } from './storage.routes';
import { ViewportComponent } from './viewport/viewport.component';
import { RvDraggableModule } from '../rv-draggable/rv-draggable.module';
import { ActionLinkDirective } from '../accessibility/directives/action-link/action-link.directive';

@NgModule({
  declarations: [
    StorageGridViewComponent,
    StorageFileNamePipe,
    ThumbnailImageComponent,
    StorageListViewComponent,
    StorageFileTypePipe,
    StorageFileSizePipe,
    EmptyStateComponent,
    UploadComponent,
    ListGridToggleComponent,
    FilesListComponent,
    NewFolderModalComponent,
    RenameFileModalComponent,
    FolderSelectorModalComponent,
    StorageModalComponent,
    StorageIframeComponent,
    StorageSelectorComponent,
    StorageHomeComponent,
    ViewportComponent,
  ],
  imports: [
    ActionLinkDirective,
    CommonModule,
    FormsModule,
    UIRouterModule.forChild(routes),
    ApiModule,
    ComponentsModule,
    SharedModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    ScrollingModule,
    RvDraggableModule,
    NoResultsComponent,
    FolderPathComponent,
    OperationsMenuComponent,
    DialogHeaderComponent,
  ],
  exports: [ListGridToggleComponent],
  providers: [StorageFileTypePipe],
})
export class StorageModule {}
